import React from "react"
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa"

export const TopBar: React.FC = () => {
	return (
		<div className='bg-accent text-white py-2'>
			<div className='container mx-auto flex flex-col md:flex-row justify-between items-center px-6 text-sm'>
				{/* Reszta elementów po lewej stronie */}
				<div className='flex-grow'></div>{" "}
				{/* Używamy flex-grow, żeby elementy po prawej stronie były wypychane na prawo */}
				{/* Telefon i e-mail przeniesione na prawą stronę */}
				<div className='flex items-center space-x-4'>
					<div className='flex items-center space-x-2'>
						<FaPhoneAlt />
						<span>+48 693 530 800</span>
					</div>
					<div className='flex items-center space-x-2'>
						<FaEnvelope />
						<span>
							<a href='mailto:biuro@ep-uslugi.pl' className='hover:underline'>
								biuro@ep-uslugi.pl
							</a>
						</span>
					</div>
				</div>
			</div>
		</div>
	)
}
